import { useMemo } from "react";
import { useTranslation } from "react-i18next";
const k = {
    dialogHeader: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.forward-dialog.forward-dialog-i18n.dialogHeader",
    employeeLabel: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.forward-dialog.forward-dialog-i18n.employeeLabel",
    commentLabel: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.forward-dialog.forward-dialog-i18n.commentLabel",
    submitButtonText: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.forward-dialog.forward-dialog-i18n.submitButtonText"
};
export const translations = {
    da: {
        dialogHeader: "Videregiv faktura",
        employeeLabel: "Medarbejder",
        commentLabel: "Kommentar",
        submitButtonText: "Videregiv"
    },
    en: {
        dialogHeader: "Forward invoice",
        employeeLabel: "User",
        commentLabel: "Comment",
        submitButtonText: "Forward"
    }
};
export const useT = () => {
    const { t, i18n } = useTranslation();
    const localT = useMemo(() => ({
        dialogHeader: t(k.dialogHeader),
        employeeLabel: t(k.employeeLabel),
        commentLabel: t(k.commentLabel),
        submitButtonText: t(k.submitButtonText)
    }), [i18n.language]);
    return useMemo(() => ({ t: localT, i18n }), [localT, i18n]);
};
